// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesMatchesEntity } from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import {
  selectMultiviewItemPerLine,
  selectMultiviewUserOption,
} from '../../selectors/multiview/multiviewPrimary.selector';
import { MatchEntityStatus, type MatchState } from '../../states/entities/matches';
import { MatchStatuses } from '../../types/match';
import { type Selector } from '../../types/selectors';

const selectIsLoading: Selector<boolean> = createSelector([selectEntitiesMatchesEntity], (match) => {
  if (match === null) return false;
  if (match === undefined) return true;
  return match?.status === undefined;
});

const selectIsNull: Selector<boolean> = createSelector([selectEntitiesMatchesEntity], (match) => match === null);

const selectItemPerLine: Selector<number> = createSelector([selectMultiviewItemPerLine], (itemPerLine) => itemPerLine);

const selectUserOption: Selector<number> = createSelector([selectMultiviewUserOption], (userOption) => userOption);

const selectIsLive: Selector<boolean> = createSelector([selectEntitiesMatchesEntity], (match) =>
  match ? MatchEntityStatus.isLive(match?.status ?? MatchStatuses.ENDED) : false,
);

type MultiviewBlockMatchPropsType = {
  entity?: MatchState;
  isLoading: boolean;
  isNull: boolean;
  itemPerLine: number;
  userOption: number;
  isLive: boolean;
};

const selectMultiviewBlockMatchProps: Selector<MultiviewBlockMatchPropsType> = createSelector(
  [selectEntitiesMatchesEntity, selectIsLoading, selectIsNull, selectItemPerLine, selectUserOption, selectIsLive],
  (entity, isLoading, isNull, itemPerLine, userOption, isLive) => ({
    entity,
    isLoading,
    isNull,
    itemPerLine,
    userOption,
    isLive,
  }),
);

export default selectMultiviewBlockMatchProps;
